import { CSSObjectWithLabel } from 'react-select';

export const commonSelectStyles = {
  control: (provided: CSSObjectWithLabel, state: any) => ({
    ...provided,
    borderColor: 'hsl(0, 0%, 70%) !important',
    boxShadow: state.isFocused ? '0 0 0 1px silver !important' : provided.boxShadow,
  }),
  menuPortal: (provided: CSSObjectWithLabel) => ({ ...provided, zIndex: 10 }),
  menu: (provided: CSSObjectWithLabel) => ({ ...provided, zIndex: 10 }),
  option: (provided: CSSObjectWithLabel, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#333' : state.isFocused ? '#F0F0F0' : '#FFF',
    color: state.isSelected ? '#F0F0F0' : '#333',
  }),
};
